import { useState, useEffect, useContext }from 'react'
import LineGraph from '../LineGraph';
import { Link } from 'react-router-dom';
import { UserContext } from '../UserContext';
import api from '../httpClient';

const DashBoard = () => {
  const [ data, setData ] = useState({ devices: [] });
  const [ loading, setLoading ] = useState(true);
  const [error, setError] = useState(null);
  const { user } = useContext(UserContext);

  // Token data includes [ sub, user_name, company_id ]
  // const decoded =  user ? jwtDecode(user.jwt) : '';
  // console.log(`Dashboard has user ${decoded.user_name}`);

  useEffect(() => {
    const fetchDevices = async () => {
      setError(null);
      try {
        const res = await api.get("/device-map");
        setData(res.data);
        setLoading(false);
      } catch (err) {
        setError(err);
        console.error("Error fetching data:", err);
        setLoading(false);
      }
    }
    fetchDevices();
  }, []);

  // Filter devices by type 'cell' because lora devices have no files on the backend at present.
  const devices = data?.devices
    ? data.devices
      .filter(device => device?.type === 'cell') 
      .map(device => ({
        devId: device.devId, 
        siteName: device.siteName,
      }))
    : [];   // Maybe change this to some other form of error message, surrently just an empty array.



  if (loading) {
    return (
      <div>
        <p>Loading Dashboard...</p>
      </div>
    );
  }

  console.log('devices on dashboard:', devices);
  return (
    <>
      <div>
        <h1>{data.company || error}</h1>
        <div className="container">{/*<div className="dashboard-container"></div>*/}
          {devices.map((device, index) => (
            <div key={index} className='device-box'>
              <p>{`${device.siteName} - `}
                <Link 
                  to={(`/site-data/${device.devId}?days=0&siteName=${encodeURIComponent(device.siteName)}`)}
                  state={device}
                  >more data
                </Link>
              </p>
              <div className="dashboard-graph" id={`pressure-container-${index}`}>
                <LineGraph device={device.devId} graphId={`pressure-container-${index}`} metric="Pressure"/>
              </div>
              <div className="dashboard-graph" id={`flow-container-${index}`}>
                <LineGraph device={device.devId} graphId={`flow-container-${index}`} metric="Flow"/>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}
export default DashBoard